import React from 'react';
import { useLocation } from 'react-router-dom';

import Button, { BUTTON_SIZES, BUTTON_TYPES } from '@buyside/components/presentation/Button/button';
import Link from '@buyside/components/presentation/Link/link';
import ParsedHtml from '@buyside/components/presentation/ParsedHtml/parsedHtml';

import { allocatorProfileUrl } from '@buyside/util/urlHelper';

import PieChartIcon from '@buyside/svgs/pie_chart.svg';

import { AllocatorProfileCardFragment } from '@interfaces/graphql-typings';

import styles from '@buyside/components/presentation/AllocatorProfileIndexPage/AllocatorProfileIndexItem/allocatorProfileIndexItemStyles.scss';

const AllocatorProfileIndexItem: React.FC<{ node: AllocatorProfileCardFragment }> = ({ node }) => {
  const { search } = useLocation();

  const {
    aumRange,
    bio,
    employerType,
    fundManager,
    highlights,
    location,
    name,
    publicBio,
    undisclosed,
    vanityLink
  } = node || {};

  const displayName =
    name || `${location || 'N/A'}-Based ${aumRange || ''} ${employerType || 'N/A'}`;

  let bioHtml = bio || publicBio;

  if (highlights && search.includes('text=')) bioHtml = JSON.parse(highlights).bio || null;

  return (
    <div className={styles.allocatorProfileIndexItem}>
      <div className={styles.itemHeader}>
        <div className={styles.headerInfo}>
          <PieChartIcon className={styles.pieChartIcon} />
          <div>
            <div className={styles.allocatorName}>
              {vanityLink ? (
                <Link to={allocatorProfileUrl(vanityLink)}>
                  <h4>{displayName}</h4>
                </Link>
              ) : (
                <h4>{displayName}</h4>
              )}
            </div>
            <div>{aumRange && !undisclosed ? aumRange + ' AUM' : 'AUM Withheld'}</div>
          </div>
        </div>
        <div className={styles.headerActions}>
          {vanityLink && (
            <Button
              size={BUTTON_SIZES.SMALL}
              text="View Details"
              type={BUTTON_TYPES.LINK}
              url={allocatorProfileUrl(vanityLink)}
            />
          )}
        </div>
      </div>
      <br />
      <div className={styles.dataPoints}>
        {[
          { name: 'Type', val: employerType },
          { name: 'Location', val: location },
          { name: 'Managed By', val: fundManager }
        ].map(dataPoint => (
          <div key={dataPoint.name}>
            <div className={styles.dataPointName}>{dataPoint.name}</div>
            <div className={styles.dataPointValue}>{dataPoint.val || 'N/A'}</div>
          </div>
        ))}
      </div>
      {bioHtml && (
        <>
          <br />
          <ParsedHtml html={bioHtml}>
            {({ content }): React.ReactNode => (
              <div className={styles.cardDescription}>{content}</div>
            )}
          </ParsedHtml>
        </>
      )}
    </div>
  );
};

export default AllocatorProfileIndexItem;
